var $faf2ebb6c0b92731$exports = {};
class $faf2ebb6c0b92731$var$HtmlTemplate extends HTMLElement {
    constructor(){
        super();
        this.attachShadow({
            mode: "open"
        });
    }
    static get observedAttributes() {
        return [
            "contents"
        ];
    }
    attributeChangedCallback(name, _, newValue) {
        if (name == "contents") this.shadowRoot.innerHTML = newValue;
    }
}
window.customElements.define("html-template", $faf2ebb6c0b92731$var$HtmlTemplate);


//# sourceMappingURL=provider-portal.ea138874.js.map
